<div *ngIf="currentUser" class="hello-band py-4 mb-3"  [style.backgroundColor]="''+chapter['backgroundColor']+''">
	<div class="container">
		<div class="row">
			 <div class="col-12 pt-1">
			</div>
		</div>
	</div>
</div>
<section *ngIf="currentUser" class="container-fluid main sections">
	<div class="container p-3">
		<section class="last-lesson-alert-container" *ngIf="currentUser && currentUser['lastLessonId']" [ngClass]="{'bg-info': currentUser['lastLessonImage'] == ''}">
			<a routerLink="/les/{{currentUser['lastLessonId']}}" [style.background-image]="'url(' + currentUser['lastLessonImage'] + ')'">
				<span class="routingText">Je bent gebleven bij</span>
				<span class="routingTitle">{{currentUser['lastLessonName']}}</span>
			</a>
		</section>
	</div>
</section>
<div class="container-fluid band p-3" *ngIf="!currentUser" [style.backgroundColor]="''+chapter['backgroundColor']+''">
	<div class="container px-3">
		<div class="row">
	    <div class="col-12 col-md-6 text-center">
        	<img [src]="introImage" class="img-fluid" alt="{{systemTitle}} ⋆ {{systemSlogan}}" />
			</div> 
			<div class="col-12 col-md-5 my-5 my-sm-0 mt-sm-5 d-flex">
				<div class="d-flex align-items-center">
					<div class="d-block">
            			<div class="text-white"><h2 class="section-title">{{sectionIntro}}</h2></div>
            			<p class="mt-3"><a href="{{salesWebsite}}" title="Lees meer over {{systemTitle}}" class="btn  btn-success">Meer over {{systemTitle}}</a></p>
					</div>
				</div>
			</div>
	    </div>
	</div>
</div>
<div class="container pt-3 mt-4" *ngIf="lessons">
	<div class="row">
		<ng-container *ngFor="let lesson of lessons">
			<div class="mb-4 col-md-6"  [ngClass]="{
				'col-xl-4': chapter['style'] == '3_COLUMN',
				'col-xl-6': chapter['style'] != '3_COLUMN'
			}">
				<div class="card">
					<img src="{{lesson['image']}}" class="card-img-top" alt="{{lesson['name']}}" />
					<div class="card-body p-5">
						<h3 class="card-title" style="font-size: 150%;">{{lesson['name']}}</h3>
						<p class="card-text" [innerHTML]="text(lesson['description'])"></p>
					</div>
					<div class="mt-auto m-5">
						<a href="/les/{{lesson['id']}}" class="btn btn-card stretched-link px-3" title="Ga naar deze les">
							Ga naar deze les <i class="fas fa-caret-right"></i>
						</a>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>

<div class="container pt-3" *ngIf="choiceAssignments.length > 0">
	<div class="row">
		<div class="col-12 pb-3"><h2>{{choiceAssignmentTitle}}</h2></div>
	</div>
	<div class="row">
		<ng-container *ngFor="let lesson of choiceAssignments">
			<div class="mb-4 col-md-6"  [ngClass]="{
				'col-xl-4': chapter['style'] == '3_COLUMN',
				'col-xl-6': chapter['style'] != '3_COLUMN'
			}">
				<div class="card">
					<img src="{{lesson['image']}}" class="card-img-top" alt="{{lesson['name']}}" />
					<div class="card-body p-5">
						<h3 class="card-title" style="font-size: 150%;">{{lesson['name']}}</h3>
						<p class="card-text" [innerHTML]="text(lesson['description'])"></p>
					</div>
					<div class="mt-auto m-5">
						<a href="/les/{{lesson['id']}}" class="btn btn-card stretched-link px-3" title="Ga naar deze les">
							Ga naar deze les <i class="fas fa-caret-right"></i>
						</a>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</div>
